import { render } from "./CarCard.vue?vue&type=template&id=0057c228&scoped=true"
import script from "./CarCard.vue?vue&type=script&lang=js"
export * from "./CarCard.vue?vue&type=script&lang=js"

import "./CarCard.vue?vue&type=style&index=0&id=0057c228&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0057c228"]])

export default __exports__